import { render } from "./DevolverFerramenta.vue?vue&type=template&id=1f798a0e&scoped=true"
import script from "./DevolverFerramenta.vue?vue&type=script&lang=js"
export * from "./DevolverFerramenta.vue?vue&type=script&lang=js"

import "./DevolverFerramenta.vue?vue&type=style&index=0&id=1f798a0e&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f798a0e"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QToggle,QTabs,QTab,QLinearProgress,QTable,QCard,QTooltip,QImg,QTr,QTh,QTd,QBtn,QDialog,QCardSection,QSeparator,QCardActions,QPagination});qInstall(script, 'directives', {ClosePopup});
